module.exports = __webpack_public_path__ + "img/issuance-step-1.45671b0a.png";